module.exports = "<div class=\"members-map__map-container\">\n  <leaflet-map class=\"leaflet-map leaflet-map--members-map\"\n               zoom=\"5\"\n               marker-points=\"$ctrl.members\">\n  </leaflet-map>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/screens/engineer/screens/members/screens/members-map/members-map.html
// module id = 322
// module chunks = 0